import type { CampaignRole } from '@/entities/media-campaign';

/**
 * The role a newly linked campaign starts with. Mirrors the backend's
 * `defaultRoleForPlatform`, and stays editable afterwards - a CM360 account can be the
 * only source for a buy made outside the platforms we have connected.
 */
export function defaultRoleFor(platform: string): CampaignRole {
  return platform === 'cm360' ? 'ad_serving' : 'buying';
}

/**
 * The channel a linked campaign starts in.
 *
 * `CreateMediaCampaignDto` requires a channel and the platform APIs do not report one, so
 * it is inferred from where the media was bought and stays editable on the Campaigns tab.
 * Inferring beats defaulting everything to one value, which would make the channel filter
 * useless the moment a project mixes search and social.
 */
/* eslint-disable i18next/no-literal-string -- channel slugs sent on the wire, not copy */
export function defaultChannelFor(platform: string): string {
  switch (platform) {
    case 'google_ads':
    case 'microsoft_ads':
      return 'search';
    case 'meta_ads':
    case 'tiktok_ads':
    case 'linkedin_ads':
      return 'social';
    case 'youtube_ads':
      return 'video';
    default:
      return 'programmatic';
  }
}
/* eslint-enable i18next/no-literal-string */
